<template>
  <div>
    <Loader v-if="loading" />
    <div class="container">
      <div v-if="reject_remark!=''" style="padding-top:3%; margin-bottom:-20px">
        <p><b>नकाराचे कारण : </b>{{ reject_remark }}</p>
      </div>
      <div v-if="survey_submitted == 1"></div>
      <div class="card" style="padding: 10px; border:none">
        <div v-if="show_survey==false">
          <h1>{{show_msg}}</h1>
        </div>
      </div>
      <div v-if="show_survey==true" style="margin-top: 10px">
        <SurveyComponent v-if="survey" :model="survey" />
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader.vue";
import 'survey-core/survey-core.css';
import { Model } from "survey-core";
import { SurveyComponent } from "survey-vue3-ui";
import data from "@/data";
import axios from "axios";
import apis from "@/apis";
import lambda from "@/apis/lambda";
import Swal from "sweetalert2";
import { themeJson } from "./theme";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

export default {
  name: "SURVEY",
  components: { Loader,SurveyComponent },
  data() {
    return {
      loading: false,
      survey: null,
      surveytemplate: {},
      sgb_board_id: "",
      employee_code: "",
      survey_id: "",
      survey_submitted: 0,
      survey_response: "",
      show_survey: true,
      show_msg: "",
      reject_remark: "",
      approval_status: "",
      jwtToken: "",
      username:""
    };
  },
  methods: {
    async Log_in() {
      try {
        this.loading = true;
        const username = this.$route.params.username;
        this.username = username;
        const details = { 
          username: username,
          type_id: 2
        };

        const response = await apis.uat_login(details);
        this.loading = false;

        if (response.data.status_code !== 200) {
          Toast.fire({ icon: "error", title: response.data.message });
          return;
        }

        const login_result = response.data;
        if (!login_result.survey_data) {
          Toast.fire({ icon: "warning", title: "record Not Found" });
          return;
        }

        // Populate survey info
        this.sgb_board_id = login_result.sgb_board_id;
        this.employee_code = login_result.user_code;
        this.jwtToken = login_result.jwtToken;
        this.survey_submitted = login_result.survey_submitted;
        this.survey_response = login_result.survey_response;
        this.survey_id = login_result.survey_data.survey_id;
        this.surveytemplate = JSON.parse(login_result.survey_data.survey_template);

        if (login_result.reject_remark) this.reject_remark = login_result.reject_remark;

        const user_survey_data = login_result.user_survey_data || {};

        // Survey visibility logic
        if (Object.keys(user_survey_data).length > 0) {
          this.approval_status = user_survey_data.approval_status;
          if (this.approval_status === "Approved") {
            this.show_msg = "तुमचा आधार तपशील मंजूर झाला आहे";
            this.show_survey = false;
          } else {
            this.show_survey = true;
          }
        } else {
          this.show_survey = true;
        }

       
      } catch (err) {
        this.loading = false;
        console.error("Login/API error:", err);
        Toast.fire({ icon: "error", title: "Something went wrong" });
      }
    },
  },
  async mounted() {
    await this.Log_in();
    if (this.surveytemplate && this.surveytemplate!= {}) 
    {   console.log(this.surveytemplate);
    
         // Apply SurveyJS theme
        this.survey = new Model(this.surveytemplate);
        
        //this.survey.applyTheme(themeJson);

        // ✅ Android 15–friendly file upload
        this.survey.onUploadFiles.add(async (survey, options) => {
          try {
            const file = options.files[0];
            const acceptedImageTypes = ["image/jpeg", "image/png"];
            if (!acceptedImageTypes.includes(file.type)) {
              options.callback("error", "कृपया फक्त (JPEG, PNG) प्रतिमा अपलोड करा.");
              return;
            }

            const filepath = options.name + "_" + file.name;
            const userid = this.username + "_Aadhar";
            const signedUrl = await lambda.getSignedURL(userid, filepath, file.type);

            const res = await fetch(signedUrl, {
              method: "PUT",
              headers: { "Content-Type": file.type },
              body: file,
            });

            if (!res.ok) throw new Error("Upload failed");

            options.callback("success", [
              {
                file,
                content: `https://s3.ap-south-1.amazonaws.com/sgbimages/${userid}/${filepath}`,
              },
            ]);

            // Reset file input to allow re-upload of same file
            setTimeout(() => {
              const input = document.querySelector('input[type="file"]');
              if (input) input.value = "";
            }, 100);

          } catch (err) {
            console.error(err);
            options.callback("error", err.message || "Upload failed");
          }
        });

             this.survey.onValueChanged.add(async(sender, options) => {
              if (options.name === "Aadhar_no" && options.value && options.value.length<12) 
              {
                options.error = "कृपया १२ अंकी वैध आधार क्रमांक प्रविष्ट करा.";
                return;
              }
               if (options.name === "Aadhar_no" && options.value && options.value.length==12) 
               {
                      const details = {
                      sgb_board_id: this.sgb_board_id,
                      emp_code: this.employee_code,
                      aadhar: options.value
                    };
                    const headers = {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${this.jwtToken}`,
                    };
                    this.loading = true;
                    const saveResp = await apis.checkAdhar(details, { headers });
                     this.loading = false;
                    if (saveResp.data.status) {
                     
                        Toast.fire({ icon: "error", title: "हा आधार क्रमांक आधीच अस्तित्वात आहे." });

                        // ❌ Clear value
                        sender.clearValue("Aadhar_no");

                        // ❌ Keep field focused
                        const q = sender.getQuestionByName("Aadhar_no");
                        if (q) q.focus();
                    }
               }
             });
        // Survey completion
        this.survey.onComplete.add(async (survey) => {
          this.loading = true;
          const surveyResult = JSON.stringify(survey.data);
          const details = {
            sgb_board_id: this.sgb_board_id,
            emp_code: this.employee_code,
            survey_id: this.survey_id,
            survey_response: surveyResult,
            type: "submit",
          };
          const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.jwtToken}`,
          };

          const saveResp = await apis.save_guard_survey_new(details, { headers });
          this.loading = false;

          if (saveResp.data.status) {
            Toast.fire({ icon: "success", title: saveResp.data.message });
          } else {
            Toast.fire({ icon: "error", title: saveResp.data.message });
          }
        });

        if (this.survey_response) this.survey.data = JSON.parse(this.survey_response);

    }
  },
};
</script>

<style scoped>
.wrapper { display: flex; flex-direction: column; min-height: 91vh; }
.container { flex: 1; }
.card:last-child { margin-top: 5%; }
.error { color: red; }
</style>
